export const styles = {
  container:
    "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-800 rounded-lg p-4 relative before:absolute before:left-0 before:right-0 before:top-[60px] before:h-[1px] before:bg-gray-100 dark:before:bg-gray-700",
  header: "px-0 py-1",
  title: "pb-4 text-xl font-semibold text-gray-800 dark:text-white/90",
  formContainer: "bg-white dark:bg-gray-800 rounded-lg mt-4 overflow-hidden",
  form: "grid grid-cols-1 md:grid-cols-3 gap-8 items-start",
  inputContainer: "col-span-3 grid grid-cols-1 md:grid-cols-3 gap-y-4 gap-x-6",
  label: "text-sm font-medium text-gray-800 dark:text-white/90 mb-1 block",
  input:
    "h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 bg-transparent text-gray-800 border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring-brand-500/10",
  inputError:
    "border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10",
  inputDefault:
    "border-gray-300 dark:border-gray-600 focus:border-brand-300 dark:focus:border-brand-800 focus:ring focus:ring-brand-500/10",
  errorText: "text-red-500 dark:text-red-400 text-xs mt-0 inline-block",
  fileUploadOuterContainer:
    "relative flex flex-col items-center bg-white dark:bg-gray-900 rounded-lg shadow-md dark:shadow-gray-800 p-4 hover:shadow-lg dark:hover:shadow-gray-700 transition-shadow",
  fileUploadInnerContainer: "flex items-center justify-between w-full mb-4",
  fileUploadButton:
    "px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-700 dark:to-blue-800 text-white rounded-lg text-sm font-medium shadow-md hover:from-blue-600 hover:to-blue-700 dark:hover:from-blue-800 dark:hover:to-blue-900 cursor-pointer transition-all duration-200",
  fileUploadTextContainer: "w-full text-center",
  fileUploadRemoveButton: "text-red-500 hover:text-red-700",
  imagePreviewContainer:
    "relative group cursor-pointer bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-lg dark:shadow-gray-800",
  imagePreview:
    "w-22 h-32 object-cover rounded-xl border border-gray-200 dark:border-gray-700",
  imagePreviewOverlay:
    "absolute inset-0 rounded-xl bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center",
  imagePreviewText:
    "text-white dark:text-gray-200 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300",
  imagePreviewModal:
    "max-w-4xl p-4 bg-white dark:bg-gray-900 rounded-lg shadow-xl",
  imagePreviewModalContent:
    "flex justify-center items-center h-full",
  imagePreviewModalImage:
    "w-[600px] h-[400px] object-contain rounded-lg",
  addFileButton:
    "flex items-center space-x-2 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors",
  buttonsContainer:
    "col-span-3 p-2 flex justify-end gap-2 w-full",
  submitButton:
    "px-6 py-2 text-sm bg-[#2f6aa7] dark:bg-[#3d6794] text-white rounded-lg hover:bg-[#2779bd] dark:hover:bg-[#335877] w-auto",
  cancelButton:
    "px-4 py-2 text-sm bg-white text-gray-700 ring-1 ring-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-900 dark:text-gray-300 dark:ring-gray-600 dark:hover:bg-gray-600 w-auto",
  required: "text-error-500 dark:text-red-400",
  modal:
    "w-[80%] max-w-[400px] bg-white dark:bg-gray-900 px-6 py-6 rounded-lg shadow-xl mx-auto text-center relative",
  modalCloseButton:
    "absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200",
  modalIconContainer:
    "w-14 h-14 flex items-center justify-center bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-400 rounded-full mx-auto",
  modalTitle: "text-lg font-bold text-gray-800 dark:text-white mt-4",
  modalText: "text-sm text-gray-500 dark:text-gray-400 mt-2",
  modalButtonContainer: "mt-6 flex justify-center",
  modalButton:
    "px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-600",
  datePickerContainer: "",
};
